import { useMutation } from "@tanstack/react-query";
import { resetPassword, type ResetPasswordRequest, type MessageResponse } from "../api/auth.api";
import { ApiError } from "@/lib/api/client";

/**
 * Mutation hook for resetting a password with a token.
 */
export function useResetPassword() {
  return useMutation<MessageResponse, ApiError, ResetPasswordRequest>({
    mutationFn: ({ token, password }) => resetPassword(token, password),
  });
}
